import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';

const Header = () => {
    return (
        <>
            {/* <div>
                Logo Here
            </div> */}
            <Navbar className='custom-nav py-3' style={{ backgroundColor: "" }} variant="dark">
                <Container>
                    <Navbar.Brand href="https://amer-bari.vercel.app/">
                        <img style={{width:'70px'}} src="https://i.ibb.co/5j9dMRK/Amer-Bari-Logo-2-01.jpg" alt="" />
                    </Navbar.Brand>
                    <Nav className="ml-auto">
                        <Nav.Link href="#home">হোম</Nav.Link>
                        <Nav.Link href="#features">আম সমূহ</Nav.Link>
                        <Nav.Link href="#pricing">ভিডিও</Nav.Link>
                        <Nav.Link href="#pricing">ব্লগ</Nav.Link>
                    </Nav>
                </Container>
            </Navbar>
        </>
    );
};

export default Header;